import request from '@/utils/request'
const wxLogin = (appid, url) => {
    let redirect_uri = encodeURIComponent(url)
    window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=nixingzhe#wechat_redirect`
}

export function login(data) {
    return request({
      url: '/wechat/login',
      method: 'post',
      data
    })
}


export default wxLogin


// WEBPACK FOOTER //
// ./src/api/user.js